import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { sendCustomTrackingInfo } from '@panel/commons';
import Atencion from '../../../assets/img/atencion.svg';
import { Container, ButtonContainer, Img, Button } from './styles';

const UpdateDataModal = ({ onClose, userName, handleOnClick = () => {} }) => {
  const { t } = useTranslation();

  useEffect(() => {
    sendCustomTrackingInfo({
      event: 'impression_modal',
      modal_name: 'Modal actualización de datos de contacto'
    });
  }, []);

  return (
    <Container data-panel='contactosPermisos'>
      <Img data-panel='contactosPermisos-imageAtencion' src={Atencion} />
      <div className='infoContain'>
        <h3 data-panel='contactosPermisos-title'>{t('panel.contactosPermisos.ContactData.preview.modal.title')}</h3>
        <p data-panel='contactosPermisos-subTitle'>
          {t('panel.contactosPermisos.ContactData.preview.modal.info', { name: userName })}
        </p>
      </div>
      <ButtonContainer>
        <Button
          width='100%'
          className='noBorderButton'
          fontSize='18px'
          fontWeight='500'
          data-panel='contactosPermisos-cta-cancel'
          onClick={() => {
            onClose();
            sendCustomTrackingInfo({
              event: 'click_modal',
              modal_name: 'Modal actualización de datos de contacto',
              item_id: 'Cancelar'
            });
          }}
        >
          {t('panel.contactosPermisos.ContactData.preview.modal.cta_cancel')}
        </Button>
        <Button
          width='100%'
          className='solidButton'
          data-panel='contactosPermisos-cta-aceptar'
          onClick={() => {
            onClose();
            handleOnClick();
            sendCustomTrackingInfo({
              event: 'click_modal',
              modal_name: 'Modal actualización de datos de contacto',
              item_id: 'Aceptar'
            });
          }}
        >
          {t('panel.contactosPermisos.ContactData.preview.modal.cta_accept')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

UpdateDataModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired
};

export default UpdateDataModal;
